<script setup lang="ts">
const props = defineProps<{
  mainImage: string | null | undefined;
  images?: Array<unknown> | null;
  alt: string;
  imgClass?: string;
  pictureClass?: string;
  priority?: boolean;
  mediaVariants?: Array<{ media: string; mainImage: string | null | undefined }>;
}>();

const MIME_BY_EXTENSION: Record<string, string> = {
  avif: "image/avif",
  webp: "image/webp",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
};

const sources = computed(() =>
  (props.images ?? [])
    .filter((url): url is string => typeof url === "string")
    .map((url) => {
      const extension = url.split("?")[0]?.split(".").pop()?.toLowerCase() ?? "";
      return { url, type: MIME_BY_EXTENSION[extension] };
    })
    .filter((source): source is { url: string; type: string } => Boolean(source.type) && source.type !== "image/jpeg")
);

const variantSources = computed(() =>
  (props.mediaVariants ?? []).filter(
    (variant): variant is { media: string; mainImage: string } => Boolean(variant.mainImage)
  )
);
</script>

<template>
  <picture v-if="mainImage" :class="pictureClass">
    <source
      v-for="variant in variantSources"
      :key="`${variant.media}-${variant.mainImage}`"
      :media="variant.media"
      :srcset="variant.mainImage"
    />
    <source v-for="source in sources" :key="source.url" :type="source.type" :srcset="source.url" />
    <img
      :src="mainImage"
      :alt="alt"
      :class="imgClass"
      :loading="priority ? 'eager' : 'lazy'"
      :decoding="priority ? 'sync' : 'async'"
      :fetchpriority="priority ? 'high' : undefined"
    />
  </picture>
</template>
